<style lang="scss">
.post-reply {}
</style>

<!-- eslint-disable -->
<template>
  <b-card class="post-reply">
    <section v-if="loading">
      <b-spinner variant="primary" label="Loading post"></b-spinner>
    </section>
    <section v-else>
      <b-tabs content-class="mt-3">
        <b-tab title="Table View" lazy>
          <digital-reply-table :replies="replies"></digital-reply-table>
        </b-tab>
        <b-tab title="Message View" lazy>
          <digital-reply-messages :replies="replies"></digital-reply-messages>
        </b-tab>
      </b-tabs>

    </section>
  </b-card>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import DigitalRepliesService from '@/services/DigitalRepliesService';
import DigitalReplyTable from '@/views/postView/sections/postDigitalReply/DigitalReplyTable.vue';
import DigitalReplyMessages from '@/views/postView/sections/postDigitalReply/DigitalReplyMessages.vue';

export default {
  name: 'PostDigitalReply',
  components: {
    DigitalReplyTable,
    DigitalReplyMessages,
  },
  props: {
    post: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      replies: [],
      currentPage: 1,
      limit: 10,
      headers: [
        { label: `${this.$options.filters.term('prisoner')} Number`, key: 'prisoner_number' },
        { label: 'Sender', key: 'sender_name' },
        { label: 'Status', key: 'status' },
        { label: 'Updated', key: 'updated_at' },
        { label: '', key: 'actions' },
      ],
    };
  },
  computed: {
    ...mapState({}),
  },
  mounted() {
    this.getReplies();
  },
  methods: {
    getReplies() {
      this.loading = true;
      DigitalRepliesService.getRepliesByPostId(this.post._id).then(res => {
        this.replies = res.data;
      }).catch(() => {
        this.$toast.error('Could not get replies, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }).finally(() => {
        this.loading = false;
      })
    },
  },
};
</script>
